import type { ClusterNominationData, DriverFaceCluster } from '@cobliteam/common-types';
import type { StateCreator } from 'zustand';
import type { MediaSlices } from '.';

export interface ClusterNominationSliceState {
  changedDriverNomination: ClusterNominationData[];
  addChangedDriverNomination: (value: ClusterNominationData) => void;
  clearChangedDriverNomination: () => void;
  selectedClustersToNominate: DriverFaceCluster[];
  addSelectedClustersToNominate: (value: DriverFaceCluster[]) => void;
  removeSelectedClustersToNominate: (value: DriverFaceCluster) => void;
  clearSelectedClustersToNominate: () => void;
  isNominatedAccordionOpen: boolean;
  setOppenedNominatedAccordion: (value: boolean) => void;
  clearAccordionState: () => void;
}

type StateCreatorClusterNomination = StateCreator<MediaSlices, [['zustand/devtools', never]], [], ClusterNominationSliceState>;

const clusterNominationSlice: StateCreatorClusterNomination = (set) => ({
  changedDriverNomination: [],
  addChangedDriverNomination: (value: ClusterNominationData) =>
    set((state) => ({
      changedDriverNomination: [...state.changedDriverNomination, value],
    })),
  clearChangedDriverNomination: () =>
    set(() => ({
      changedDriverNomination: [],
    })),
  selectedClustersToNominate: [],
  addSelectedClustersToNominate: (value: DriverFaceCluster[]) =>
    set((state) => ({
      selectedClustersToNominate: [...state.selectedClustersToNominate, ...value],
    })),
  removeSelectedClustersToNominate: (value: DriverFaceCluster) =>
    set((state) => ({
      selectedClustersToNominate: state.selectedClustersToNominate.filter((c) => c.id !== value.id),
    })),
  clearSelectedClustersToNominate: () =>
    set(() => ({
      selectedClustersToNominate: [],
    })),
  isNonNominatedAccordionOpen: true,
  isNominatedAccordionOpen: false,
  setOppenedNominatedAccordion: (isExpanded: boolean) =>
    set(() => ({
      isNominatedAccordionOpen: isExpanded,
    })),
  clearAccordionState: () =>
    set(() => ({
      isNonNominatedAccordionOpen: true,
      isNominatedAccordionOpen: false,
    })),
});

export default clusterNominationSlice;
